type TFilterConditionalKeyValues = {
  [key: string]: false | undefined | string | (false | undefined | string)[];
};

type TFilterConditionalKeyValuesReturns = {
  [key: string]: string | string[];
};

const filterConditionalKeyValues = (keyValues: TFilterConditionalKeyValues): TFilterConditionalKeyValuesReturns => {
  const truthyKeys = {};
  for (const key in keyValues) {
    if (!keyValues.hasOwnProperty(key)) {
      break;
    }
    const values = keyValues[key];
    if (Array.isArray(values)) {
      const truthyValues = values.filter(Boolean);
      if (truthyValues.length) {
        truthyKeys[key] = truthyValues;
      }
    } else if (values) {
      truthyKeys[key] = values;
    }
  }
  return truthyKeys;
};

export default filterConditionalKeyValues;
